import { BusinessContext } from '@periscopes/general/context';
import React from 'react';

export interface PageLayoutDetailsTabProps {
	sonarObjectId: number;
}

export const PageLayoutDetailsTab: React.FC<PageLayoutDetailsTabProps> = ({ sonarObjectId }) =>
	<BusinessContext sonarObjectId={ sonarObjectId } />;

